import { transformErrorResponse } from "../../transformErrorResponse"
import { ClienteWAOOENTITY } from "sigo-entities"
import { AtcApiBuilder } from "."

export const PERU_9112_WaooOrder = (build: AtcApiBuilder) => {
    return {
        getByIdWaooOrders: build.query<ClienteWAOOENTITY[], string>({
            query: (userId) => `procesos/PERU_9112_ClienteWaoo/${userId}`,
            providesTags: (result, error, userId) =>
                result
                    ? [
                        // tag individual por cada orden
                        ...result.map((order) => ({
                            type: 'WaooOrders' as const,
                            id: order._id,
                        })),
                        // y un tag general de la lista de ese usuario
                        { type: 'WaooOrders' as const, id: `USER-${userId}` },
                    ]
                    : [{ type: 'WaooOrders' as const, id: `USER-${userId}` }],
            transformErrorResponse
        }),
        getTransitWaooOrders: build.query<{ transito: number }, { id_recurso: string, codigo: number }>({
            query: ({ id_recurso, codigo }) => `procesos/PERU_9112_ClienteWaoo/calculate-transit/${id_recurso}/${codigo}`,
            transformErrorResponse
        }),
        addInventoryWaooOrders: build.mutation<ClienteWAOOENTITY, { id: string, body: { ID_StockPersonal: number, cantidad: number, Serie?: { Serie: string, ID_StockPersonalEquipos: number } } }>({
            query: ({ body, id }) => ({
                url: `procesos/PERU_9112_ClienteWaoo/add-inventory/${id}`,
                method: "PUT",
                body,
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: 'WaooOrders' as const, id },
            ],
            transformErrorResponse
        }),
        deleteInventoryWaooOrders: build.mutation<ClienteWAOOENTITY, { id: string, codigo: number }>({
            query: ({ id, codigo }) => ({
                url: `procesos/PERU_9112_ClienteWaoo/delete-inventory/${id}/${codigo}`,
                method: "PUT",
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: 'WaooOrders' as const, id },
            ],
            transformErrorResponse
        }),
        finalizeWaooOrders: build.mutation<ClienteWAOOENTITY, { id: string }>({
            query: ({ id }) => ({
                url: `procesos/PERU_9112_ClienteWaoo/finalize/${id}`,
                method: "PUT"
            }),
            invalidatesTags: (result, error, { id }) => [
                // invalida la orden puntual
                { type: 'WaooOrders' as const, id },
                // y también la lista del usuario (para que se refresque)
                // { type: 'WINOrders' as const, id: `USER-${userId}` },
            ],
            transformErrorResponse
        })
    }
}